import React, { FC, RefCallback } from "react";

import CountUp from "react-countup";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { formatNumber } from "../../../../utils/NumberHelpers";
import Image from "../../Image";

interface iContainer {
    count: number;
}

const Container = styled.div<iContainer>`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 20px;
    column-gap: 10px;
    padding: 25px;
    color: ${({ theme }) => theme.colors.white.toString()};
    background-color: ${({ theme }) => theme.colors.blue.toString()};
    ${({ theme, count }) =>
        count > 2 &&
        theme.breakpoints.from.small.css`
       display: flex;
       justify-content: space-between;
       ${theme.paddings.containerOuterInner.left}
       ${theme.paddings.containerOuterInner.right}
    `}
    ${(props) =>
        props.count === 1 &&
        css`
            display: flex;
            justify-content: center;
            ${props.theme.breakpoints.upTo.small.css`
            & > div {
                    width: 100%;
                }
            `}
        `}
    ${(props) =>
        props.count < 4 &&
        props.count > 1 &&
        css`
            ${props.theme.breakpoints.from.small.css`
                display: flex;
                justify-content: center;
                /* stylelint-disable-next-line no-duplicate-selectors */
                & > div {
                    width: 25%;
                }
            `}
        `}
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    ${({ theme }) => theme.breakpoints.from.small.css`
          height: unset;
    `}
`;

const TextImageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ImageWrapper = styled.div`
    width: 80px;
    height: 80px;
`;

const Text = styled.div`
    margin-bottom: 15px;
    text-align: center;
`;

interface iCountWrapper {
    number?: number;
}

const CountWrapper = styled.div<iCountWrapper>`
    display: flex;
    flex-flow: row wrap;
    gap: 0;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    font-weight: 900;
    line-height: 2.2rem;
    ${({ theme }) => theme.breakpoints.from.small.css`
         gap: 5px;
    `}
    ${(p) =>
        p.number &&
        p.number >= 10000 &&
        css`
            font-size: 1.5rem;
            ${p.theme.breakpoints.from.medium.css`
                font-size: 2rem;
            `}
        `}
`;

interface iInnerWrapper {
    number: number;
}

const InnerWrapper = styled.div<iInnerWrapper>`
    display: flex;
    gap: 5px;
    justify-content: center;
    ${(p) =>
        p.number >= 10000 &&
        css`
            width: 100%;
            ${p.theme.breakpoints.from.small.css`
               width: unset;
      `}
        `}
`;

const Prefix = styled.div``;

type KeyFactsContainerProps = {
    time: string;
    facts: [
        {
            number: string;
            text: string;
            image?: any;
            prefix?: string;
            prefixTwo?: string;
        }
    ];
    factsContainer?: RefCallback<HTMLDivElement> | null;
    isVisible?: boolean;
};

const KeyFactsContainer: FC<KeyFactsContainerProps> = ({
    time,
    facts,
    isVisible,
    factsContainer,
}) => {
    return (
        <Container ref={factsContainer && factsContainer} count={facts.length}>
            {facts.map((fact, index) => {
                return (
                    <Wrapper key={index}>
                        <TextImageWrapper>
                            {fact.image && (
                                <ImageWrapper>
                                    {fact.image?.src && (
                                        <Image
                                            {...fact.image}
                                            css={css`
                                                width: 80px;
                                                height: 80px;
                                            `}
                                        />
                                    )}
                                </ImageWrapper>
                            )}
                            <Text>{fact.text}</Text>
                        </TextImageWrapper>
                        {isVisible ? (
                            <CountWrapper number={Number(fact.number)}>
                                <InnerWrapper number={Number(fact.number)}>
                                    {fact.prefix && (
                                        <Prefix>{fact.prefix}</Prefix>
                                    )}
                                    <CountUp
                                        key={fact.text}
                                        end={Number(fact.number)}
                                        duration={Number(time)}
                                        formattingFn={formatNumber}
                                    />
                                </InnerWrapper>
                                {fact.prefixTwo && (
                                    <Prefix>{fact.prefixTwo}</Prefix>
                                )}
                            </CountWrapper>
                        ) : (
                            <CountWrapper>0</CountWrapper>
                        )}
                    </Wrapper>
                );
            })}
        </Container>
    );
};

export default KeyFactsContainer;
